export const DELIVERY_METHOD = 'deliveryMethod';
export const PAYMENT_METHOD = 'paymentSourceFromMethod';

export const SPECIAL_FIELD_PREFIX = '__ifc__';
export const SPECIAL_SYS_PREFIX = '__sys_';

export const FROM_ACCOUNT = SPECIAL_FIELD_PREFIX + 'from_account';
export const SOURCE_CARD_EXP_DATE = 'source_card_exp_date';
export const CARD_EXP_DATE = 'exp_date';
export const SOURCE_CARD_CVV = 'source_card_cvv';
export const FROM_CNR_ID = SPECIAL_SYS_PREFIX + 'pay_from_cnr_id';
export const TO_CNR_ID = SPECIAL_SYS_PREFIX + 'pay_to_cnr_id';
export const SOURCE = SPECIAL_FIELD_PREFIX + 'source';
export const ACTUAL_TILL = SPECIAL_FIELD_PREFIX + 'actual_till';
export const ACCOUNT = 'account';
export const ACCOUNT_TO = SPECIAL_FIELD_PREFIX + 'to_account';
export const AMOUNT_TO = SPECIAL_FIELD_PREFIX + 'to_amount';
export const AMOUNT_TO_CCY = AMOUNT_TO + '_ccy';
export const AMOUNT_TO_ISO = AMOUNT_TO + '_iso';
export const AMOUNT_FROM = SPECIAL_FIELD_PREFIX + 'from_amount';
export const AMOUNT_FROM_ISO = AMOUNT_FROM + '_iso';
export const AMOUNT_FROM_CCY = AMOUNT_FROM + '_ccy';
export const TO_PRV_ID = 'toPrvId';
export const CVV = 'source_card_cvv';
export const CARD_CVV = 'cvv';
export const FROM_PRV_ID = 'fromPrvId';
export const KEEP_AMOUNT = 'keepAmount';
export const SOURCE_CODE_FROM = 'sourceCodeFrom';
export const SOURCE_CODE_TO = 'sourceCodeTo';
export const PROMO_CODE_FIELD = 'pay_promo_code';
export const INVITE_CODE_FIELD = 'invite_code';
export const PHONE = 'phone';
export const ACCEPTED_PAYMENT = 'acceptedPayment';
export const BILL_ISSUER_COMMENT = 'billIssuerComments';
export const BILL_ISSUER = 'billIssuer';
export const ID = 'id';
export const FROM_COUNTRY_NAME = 'fromCountryName';
export const FEE_TEXT = 'feeText';
export const CURRENCY_RATE_TEXT = 'currencyRateText';
export const AMOUNT = 'amount';
export const TO_BANK_CODE = 'to_bank_code';
export const POST_CODE = 'post_code';
export const TO_BIK = 'to_bik';
export const TO_ACCOUNT_TYPE = 'to_account_type';
export const PAN = 'pan';
export const TO_PHONE_NUMBER = 'to_phone_number';
export const TO_TRANSFER_PURPOSE = 'to_transfer_purpose';
export const TRANSFER_PURPOSE = 'transfer_purpose';
export const COMMENT = 'comment';
export const REPEAT_PAYMENT_ID = 'repeatPaymentId';
export const CODE = 'code';
export const PHONE_NUMBER = 'phone_number';
export const PHONE_PREFIX = 'phone_prefix';
export const PHONE_COUNTRY = 'phone_country';

//bank account fields
export const TO_ISSUER_CODE = 'to_issuer_code';
export const BANK_ACCOUNTCODE = 'to_bankcode';
export const BANK_ACCOUNT_CODE = 'to_bank_code';
export const BANK_ACCOUNT_ID = 'to_bank_id';
export const SWIFT_CODE = 'to_swift_code';
export const TO_RECIPIENT = 'to_recipient';
export const TO_RECIPIENT_OTHER = 'to_recipient_other';
export const TO_RECIPIENT_SELF = 'to_recipient_self';
export const TO_RECIPIENT_CATEGORY_TYPE = 'to_recipient_category_type';
export const TO_BIC = 'to_bic';
export const BIK_TYPE = 'to_bik';
export const TO_SORT_CODE = 'to_sort_code';
export const TO_COMMENT = 'to_comment';
export const TO_IBAN = 'to_iban';
export const IS_IBAN = 'is_iban';

//fields property
export const PLACEHOLDER = 'placeholder';
export const ERROR_MESSAGE = 'errorMessage';

//date fields
export const START_DATE = 'start_date';
export const END_DATE = 'end_date';
export const START_DATE_CAMELCASE = 'startDate';
export const END_DATE_CAMELCASE = 'endDate';

export const SSN = 'ssn';
export const ITIN = 'itin';

//ga pin fields
export const FIRST_PIN_FIELD = 'first_pin_field';
export const SECOND_PIN_FIELD = 'second_pin_field';
export const THIRD_PIN_FIELD = 'third_pin_field';
export const FOURTH_PIN_FIELD = 'fourth_pin_field';

// address fields
export const ADDRESS = 'address';
export const ADDRESS_2 = 'address2';
export const CITY = 'city';
export const RESIDENT_COUNTRY = 'resident_country';

// personal info
export const NAME = 'name';
export const NAME_F = 'name_f';
export const TO_NAME = 'to_name';
export const TO_NAME_F = 'to_name_f';
export const BIRTHDAY = 'birthday';
export const EMAIL = 'email';
export const OCCUPATION = 'occupation';
export const SEX = 'sex';
export const PURPOSE_OF_ACCOUNT = 'purpose_of_account';

// anti fraud
export const SOURCE_OF_INCOME = 'source_of_income'; // 24000 scenario
export const INCOME_TYPE = 'income_type'; // 22000 scenario
export const VERIFICATION_AMOUNT = 'verificationAmount';
